export default {
      id: "balloon-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#balloon",
      toString: function () {
        return this.url;
      }
    }